import { AccessTime, ArrowDownward, ArrowUpward, CancelOutlined, Download, Loop, Search, ShoppingBag, ShoppingBagOutlined, TaskAlt, ThumbUpAltOutlined, Visibility } from '@mui/icons-material'
import { Autocomplete, Box, Button, Chip, Grid, InputAdornment, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { RootState } from '../../../Redux/store';
import { orderStatusColors } from '../../../Component/OrderStatusColors/orderStatusColors';
import { paymentStatusColor } from '../../../Component/PaymentStatusColor/paymnetStatusColor';
import { Orders } from '../../../types/Orders';
import { ApiGetOrders } from '../../../Core/Apicall';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';

function AllOrders() {
  // const navigate = useNavigate()
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState<number>(-1)
  const { userDetails, } = useSelector((state: RootState) => state.global)
  const [selecetdorderStatus, setSelecetdOrderStatus] = useState<string>()
  const [selecetdPaymentStatus, setSelecetdPaymentStatus] = useState<string>()
  const [orders, setOrders] = useState<Orders[]>()
  const [serchItem, setSearchItem] = useState<string>('')
  const [debouncedSearch, setDebouncedSearch] = useState<string>('');
  const navigate = useNavigate()
  const [countData, setCountData] = useState<any>()
  

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(serchItem);
    }, 500); 

    return () => clearTimeout(timer);
  }, [serchItem]);


  const orderStatus = [
    {
      label: "Approved",
      value: 'APPROVED'
    },
    {
      label: "Processing",
      value: 'PROCESSING'
    },
    {
      label: "Completed",
      value: 'COMPLETED'
    },
    {
      label: "Rejected",
      value: 'REJECTED'
    }
  ]
  const paymentStatus = [
    {
      label: "Pending",
      value: 'PENDING'
    },
    {
      label: "Paid",
      value: 'PAID'
    },
    {
      label: "Failed",
      value: 'FAILED'
    },
  ]


  const GetOrders = async () => {
    try {
      const data = `?offset=${page * rowsPerPage}&limit=${rowsPerPage}${debouncedSearch?.trim()?.length > 0 ? `&search=${debouncedSearch}`:""}${selecetdorderStatus ? `&status=${selecetdorderStatus}`:""}${selecetdPaymentStatus ? `&paymentStatus=${selecetdPaymentStatus}`:""}`
      const res = await ApiGetOrders(data)
      if (res?.status) {
        setOrders(res?.data)
        setTotal(res?.total)
        setCountData(res?.counts)
      }
    } catch (error:any) {
      toast.error(error?.message || "Something went worng")
    }
  }

  useEffect(() => {
    GetOrders()
  }, [page,debouncedSearch, selecetdorderStatus, selecetdPaymentStatus])
  return (
    <Box className='p-lg-3 p-xl-4 p-2'>
      <Box className='d-flex mb-4  align-items-center justify-content-between'>
        <Box>
          <Typography variant='h5' className='fw-bold' sx={{ lineHeight: 'normal' }}>Orders</Typography>
          <Typography variant='body2'>Manage and track all your customer orders</Typography>
        </Box>
        <Button className='btn-outlined-main' sx={{ padding: '7px 15px' }}><Download className='m-0 p-0' />&nbsp; <span>Export</span></Button>
      </Box>
      <Grid container spacing={1} className='my-2 mb-3'>
        <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>Total Orders</Typography>
              <Typography variant='h5'>{countData?.totalOrders}</Typography>
              {/* <Typography variant='caption'> {(0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(12) >= 0 ? 'text-main' : 'text-danger'}>12.15%</span>  from last month</Typography> */}
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 bg-second-light border-10'>
                <ShoppingBagOutlined className='text-main' sx={{ fontSize: '32px' }} />
                {/* {BsPersonWorkspace({ size: 32, color: 'var(--primary-color)' })} */}
              </Box>
            </Grid>
            {/* <Grid size={{xs:12}}>
              <Typography variant='caption'> {(0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(12) >= 0 ? 'text-main' : 'text-danger'}>12.15%</span>  from last month</Typography>
            </Grid> */}
          </Grid>
        </Grid>
        <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>Pending Orders</Typography>
              <Typography variant='h5'>{countData?.pendingOrders}</Typography>
              {/* <Typography variant='caption'> {(8.3) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(8.3) >= 0 ? 'text-main' : 'text-danger'}>{8.3}%</span>  from last month</Typography> */}
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['PENDING'].bg} !important` }}>
                <AccessTime sx={{ fontSize: '32px', color: `${orderStatusColors['PENDING'].color} !important`, }} />
                {/* {AiOutlineProduct({ size: 32, color: 'var(--primary-color)' })} */}
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>Processing Orders</Typography>
              <Typography variant='h5'>{countData?.processingOrders}</Typography>
              {/* <Typography variant='caption'> {(456) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(456) >= 0 ? 'text-main' : 'text-danger'}>{456}%</span>  from last month</Typography> */}
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['PROCESSING'].bg} !important` }}>
                <Loop sx={{ fontSize: '32px', color: `${orderStatusColors['PROCESSING'].color} !important`, }} />
                {/* {AiOutlineProduct({ size: 32, color: 'var(--primary-color)' })} */}
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>Completed Orders</Typography>
              <Typography variant='h5'>{countData?.completedOrders}</Typography>
              {/* <Typography variant='caption'> {(10.1) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(10.1) >= 0 ? 'text-main' : 'text-danger'}>{10.1}%</span>  from last month</Typography> */}
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['COMPLETED'].bg} !important` }}>
                <TaskAlt sx={{ fontSize: '32px', color: `${orderStatusColors['COMPLETED'].color} !important` }} />
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>Approved Orders</Typography>
              <Typography variant='h5'>{countData?.approvedOrders}</Typography>
              {/* <Typography variant='caption'> {(10.1) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(10.1) >= 0 ? 'text-main' : 'text-danger'}>{10.1}%</span>  from last month</Typography> */}
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['APPROVED'].bg} !important` }}>
                <ThumbUpAltOutlined className='text-blue' sx={{ fontSize: '32px', color: `${orderStatusColors['APPROVED'].color} !important` }} />
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>Cancelled Orders</Typography>
              <Typography variant='h5'>{countData?.rejectedOrders}</Typography>
              {/* <Typography variant='caption'> {(10.1) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(10.1) >= 0 ? 'text-main' : 'text-danger'}>{10.1}%</span>  from last month</Typography> */}
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['REJECTED'].bg} !important` }}>
                <CancelOutlined className='text-red' sx={{ fontSize: '32px', color: `${orderStatusColors['REJECTED'].color} !important` }} />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Box>
        <Box className='bg-white border-10'>
          <Box className='d-flex align-items-center justify-content-between text-field  gap-2 p-3'>
            <TextField
              className='m-0 p-0'
              value={serchItem}
              placeholder='Search by orderId,dealer...'
              sx={{ minWidth: { xs: "100%", md: '300px' } }}
              onChange={(e) => { setSearchItem(e.target.value) }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start" className='me-0'>
                      <Search fontSize="small" className='m-0 p-0' />
                    </InputAdornment>
                  ),
                },
              }}
            />
            <Box className='d-none d-md-flex align-items-center gap-2 form-text-field'>
              <Box sx={{ width: '220px' }}>
                <Autocomplete
                  fullWidth
                  options={orderStatus}
                  getOptionLabel={(option) => option.label}
                  value={orderStatus.find(option => option.value === selecetdorderStatus) || null}
                  onChange={(_, option) => {
                    setSelecetdOrderStatus(option?.value)
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Order Status..."
                    />
                  )}
                />
              </Box>
              <Box sx={{ width: '220px' }}>
                <Autocomplete
                  fullWidth
                  options={paymentStatus}
                  getOptionLabel={(option) => option.label}
                  value={paymentStatus.find(option => option.value === selecetdPaymentStatus) || null}
                  onChange={(_, option) => {
                    setSelecetdPaymentStatus(option?.value)
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Payment Status..."
                    />
                  )}
                />
              </Box>
            </Box>
          </Box>
          <TableContainer
            sx={{
              border: "1px solid #E5E7EB",
              borderRadius: "10px",
              // overflow: "hidden",
            }}
          >
            <Table sx={{ tableLayout: "fixed" }}>
              <TableHead>
                <TableRow
                  sx={{
                    bgcolor: "var(--primary-light-color)",

                    "& th": {
                      fontWeight: 600,
                      color: "#555",
                      py: 2,
                      borderBottom: "1px solid #E5E7EB",
                    },
                  }}
                >
                  <TableCell sx={{ width: 150 }}>
                    <Typography variant="caption">Order ID</Typography>
                  </TableCell>

                  <TableCell sx={{ width: 250 }}>
                    <Typography variant="caption">Dealer</Typography>
                  </TableCell>

                  <TableCell sx={{ width: 120 }} className='text-center'>
                    <Typography variant="caption">Items</Typography>
                  </TableCell>

                  <TableCell sx={{ width: 180 }} className='text-center'>
                    <Typography variant="caption">Order Date</Typography>
                  </TableCell>
                  <TableCell sx={{ width: 150 }} className='text-center'>
                    <Typography variant="caption">Amount</Typography>
                  </TableCell>

                  <TableCell sx={{ width: 180 }} className='text-center'>
                    <Typography variant="caption">Payment Status</Typography>
                  </TableCell>

                  <TableCell sx={{ width: 180 }} className='text-center'>
                    <Typography variant="caption" className='text-center'>Order Status</Typography>
                  </TableCell>

                  <TableCell sx={{ width: 180 }} className='text-center'>
                    <Typography variant="caption" className='text-center'>Shipping Amount</Typography>
                  </TableCell>

                  <TableCell sx={{ width: 120 }} className='text-center'>
                    <Typography variant="caption" className='text-center'>Actions</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orders?.map((item) => (
                  <TableRow>
                    <TableCell sx={{ width: 150 }}>
                      <Typography variant="body2">{item?.orderNumber}</Typography>
                    </TableCell>

                    <TableCell sx={{ width: 250 }}>
                      <Typography variant="body2">{item?.subClient?.companyName}</Typography>
                    </TableCell>

                    <TableCell sx={{ width: 120 }} className='text-center'>
                      <Typography variant="body2">{item?.items?.length}</Typography>
                    </TableCell>

                    <TableCell sx={{ width: 180 }} className='text-center'>
                      <Typography variant="body2">{dayjs(item?.created_at).format("DD MMM YYYY")}</Typography>
                      <Typography variant="body2">{dayjs(item?.created_at).format("HH:mm a")}</Typography>
                    </TableCell>
                    <TableCell sx={{ width: 150 }} className='text-center'>
                      <Typography variant="body2">
                        {Number(item?.totalAmount)?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ width: 180 }} className='text-center'>
                      <Chip
                        label={item?.payment_status}
                        size="small"
                        sx={{
                          backgroundColor: paymentStatusColor[item?.payment_status?.toUpperCase()].bg,
                          color: paymentStatusColor[item?.payment_status?.toUpperCase()].color,
                          fontWeight: 600,
                          borderRadius: "20px",
                          minWidth: 95,
                        }}
                      />
                    </TableCell>

                    <TableCell sx={{ width: 180 }} className='text-center'>
                      <Chip
                        label={item?.status}
                        size="small"
                        sx={{
                          backgroundColor: orderStatusColors[item?.status?.toUpperCase()].bg,
                          color: orderStatusColors[item?.status?.toUpperCase()].color,
                          fontWeight: 600,
                          borderRadius: "20px",
                          minWidth: 95,
                        }}
                      />
                      {/* <Typography variant="caption" className='text-center'>{item?.orderStatus}</Typography> */}
                    </TableCell>

                    <TableCell sx={{ width: 180 }} className='text-center'>
                      <Typography variant="body2" className='text-center'>
                        {Number(item?.shipping_amount)?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ width: 120 }} className='justify-content-center'>
                      <Box className='border p-2 border-10 mx-auto' onClick={()=>{navigate(`/${userDetails?.role}/order-details/${item?.orderId}`)}} sx={{width:'fit-content'}}>
                        <Visibility className='text-main' />
                      </Box>
                      {/* <Typography variant="body2" className='text-center'>Actions</Typography> */}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box className='p-3 d-flex justify-content-end'>
          {total > rowsPerPage &&
            <Pagination
              page={page + 1}
              count={Math.ceil(total / rowsPerPage)}
              onChange={(_, value) => setPage(value - 1)}
              shape="rounded"
              // color="primary"
              sx={{
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: 'var(--primary-color)',
                  color: 'white'
                }
              }}
              showFirstButton={false}
              showLastButton={false}
              siblingCount={1}
              boundaryCount={1}
            />}
        </Box>
      </Box>



    </Box>
  )
}

export default AllOrders
